const CERTIFICATION_STATUS = {
  NEEDS_INFO: 'needs info',
  VERIFIED: 'verified',
  VERIFICATION_PENDING: 'verification pending',
  REJECTED: 'rejected',
  EXPIRED: 'expired'
};

export default CERTIFICATION_STATUS;
